import { Injectable, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { FilterMenuOptions } from '../../models';
import { FilterMenuFormUtilityService } from '../utility-services';
import { Field, FilterMenuServiceModel } from './models';

@Injectable({
    providedIn: 'root'
})

export class DashboardsFiltersMenuLogicService {

    model: FilterMenuServiceModel = new FilterMenuServiceModel();

    constructor(
        private _filterMenuFormUtilityService: FilterMenuFormUtilityService,
        private _formBuilder: UntypedFormBuilder,
    ) { }

    initModel(): void {
        this.model = new FilterMenuServiceModel();
        this.model.form = this._formBuilder.group({});
        this.model.filterMenuOptions = new FilterMenuOptions();
    }

    dataChanges(changes: SimpleChanges, inputtedDashboardFilterMenuOptions: FilterMenuOptions): void {
        this._filterMenuFormUtilityService.dataChanges(changes, inputtedDashboardFilterMenuOptions, this.model);
    }

    createForm(): UntypedFormGroup {
        return this._filterMenuFormUtilityService.createForm(this.model);
    }

    resetDashboardsFilterForm(): void {
        this.model.form = this.createForm();
    }

    openFilterMenu(): void {
        this.model.expandFilterMenu = true;
    }

    closeFilterMenu(): void {
        this.model.expandFilterMenu = false;
    }

    toggleSeeMore(id: string): void {
        this.model.seeMoreStatus[id] = !this.model.seeMoreStatus[id];
    }

    getVisibleValues(id: string): (Date | boolean | number | string)[] {
        return this.model.seeMoreStatus[id] ? this.model.filterMenuOptions.filterValues[id] : this.model.filterMenuOptions.filterValues[id].slice(0, 5);
    }

    getDashboardFilteredMenuOptionsForSites(): FilterMenuOptions {
        return this._filterMenuFormUtilityService.getFilteredMenuOptionsForSites(this.model);
    }

    isDashboardFilterTitleUnderCharacterCap(mapFilterField: Field): boolean {
        return mapFilterField.Name.length < this.model.characterCap;
    }

    getDashboardFilterFieldDisplayTitle(mapFilterField: Field): string {
        if (this.isDashboardFilterTitleUnderCharacterCap(mapFilterField)) {
            return mapFilterField.Name;
        }
        return mapFilterField.Name.slice(0, this.model.characterCap - this.model.cutOffString.length) + this.model.cutOffString;
    }
}
